import { tempList } from "../light/type";

export default {
  computed: {
    temp() {
      return this.$route.params.temp;
    },
    tempOption() {
      return tempList.find((item) => item.key == this.temp);
    },
    apiPrefix() {
      return this.tempOption?.apiPrefix;
    },
  },
};
